'use client';

import { lineMapping } from '@/lib/lineMapping';
import { simMapping } from '@/lib/simMapping';
import { statusMapping } from '@/lib/statusMapping';
import type { MobileLine } from '@octave/contracts';
import { ColumnDef } from '@tanstack/react-table';
export const columns: ColumnDef<MobileLine>[] = [
  {
    id: 'number',
    accessorKey: 'number',
    header: 'Numéro',
    filterFn: 'includesString',
  },
  {
    id: 'user',
    accessorFn: (row) =>
      row.identity ? `${row.identity.firstName} ${row.identity.lastName}` : '-',
    header: 'Utilisateur',
    filterFn: 'includesString',
  },
  {
    id: 'type',
    accessorFn: (row) => (row.phonePlan.isDataOnly ? 'dataonly' : 'classic'),
    header: 'Type de ligne',
    cell: ({ row }) => {
      const type = row.getValue('type') as string;
      return type ? lineMapping[type] || type : '-';
    },
    filterFn: (row, _, filterValue) => {
      if (!filterValue) return true;
      const type = row.original.phonePlan.isDataOnly ? 'dataonly' : 'classic';
      return type === filterValue;
    },
  },
  {
    id: 'phonePlan',
    accessorFn: (row) => row.phonePlan.name || '-',
    header: 'Forfait',
  },
  {
    id: 'status',
    accessorKey: 'status',
    header: 'Statut',
    cell: ({ row }) => {
      const status = row.getValue('status') as string;
      return (
        <span
          className={`px-2 py-1 text-xs font-semibold rounded-full ${
            status === 'used'
              ? 'bg-green-100 text-green-800'
              : status === 'restricted'
              ? 'bg-yellow-100 text-yellow-800'
              : 'bg-red-100 text-red-800'
          }`}
        >
          {statusMapping[status] || status}
        </span>
      );
    },
  },
  {
    id: 'operator',
    accessorFn: (row) => row.phonePlan.operator.name,
    header: 'Réseau',
  },
  {
    id: 'sim',
    accessorFn: (row) => row.simCard?.type || '-',
    header: 'SIM',
    cell: ({ row }) => {
      const simType = row.original.simCard?.type;
      return simType ? simMapping[simType] || simType : '-';
    },
    filterFn: (row, _, filterValue) => {
      if (!filterValue) return true;
      const simType = row.original.simCard?.type;
      return simType === filterValue;
    },
  },
  {
    id: 'site',
    accessorFn: (row) => row.site.name,
    header: 'Centre de facturation',
  },
];
